import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import "./Messaggi.css";
import BLib from "../BLib.mjs";
import MessaggiAreaHeader from "./MessaggiAreaHeader.mjs";
import EditMessage from "./EditMessage.mjs";
import MessaggiRender from "./MessaggiRender.mjs";
import ReportInappropriate from "./ReportInappropriate.mjs";
import ReplyByMail from "./ReplyByMail.mjs";

const prefix = "Messaggi";

const Messaggi = class extends Component {
	constructor(props) {
		super(props);
		const u = appLib.currentUser();
		this.state = {
			user: u,
			canAdmin: (u?.admin||u?.moderator),
			axle: props.axle ?? 'cerco',
		};
		this.state.messaggi = BLib.data(this.state.axle);
		this.uid = Glob.generateUid(prefix);
		this.calcClassName = this.calcClassName.bind(this);
	}
	componentDidMount() {
		Glob.register('currentUser', ui => {
			this.setState({user: ui, canAdmin: (ui?.admin||ui?.moderator)}, this.calcClassName);
		}, this.uid);
		Glob.register('MessaggeEdit', m => {
			this.setState({composing: m});
		}, this.uid);
		Glob.register('ReplyByMail', m => {
			this.setState({reply: m});
		}, this.uid);
		Glob.register('DatiBacheca-'+this.state.axle, data => {
			this.setState({messaggi: data });
		}, this.uid);
		Glob.register('ReportInappropriate', data => {
			this.setState({reporting: data });
		}, this.uid);
		this.calcClassName();
		BLib.startPoll();
	}
	componentWillUnmount() {
		BLib.stopPoll();
		Glob.deregister(this.uid);
	}
	calcClassName() {
		this.setState({className: `${prefix} ${prefix}-${this.state.axle} ${this.state.user ? 'auth-user' : 'no-auth-user'}${ this.state.canAdmin ? ' auth-admin' : ''}`});
	}
	render() {
		if ( ! this.state.className ) return null;
		return (
			<div
				className={this.state.className}
				id={this.uid}
				key={ this.state.user?.email || 'anonymous'}
			>
				{ (this.state.user && this.state.composing) ? (
					<EditMessage
						value={ this.state.composing }
						axle={ this.state.axle }
						user={ this.state.user }
					/>
				) : (
					<>
						<MessaggiAreaHeader
							tot={ this.state.messaggi ? this.state.messaggi.length : null }
							axle={this.state.axle}
							user={this.state.user}
						/>
						<MessaggiRender
							user={this.state.user}
							axle={this.state.axle}
							data={this.state.messaggi}
						/>
					</>
				) }
				{ this.state.reporting && (
					<ReportInappropriate
						message={ this.state.reporting }
						user={ this.state.user }
					/>
				)}
				{ this.state.reply && (
					<ReplyByMail
						message={ this.state.reply }
						user={ this.state.user }
					/>
				)}
			</div>
		)
	}
}

export default Messaggi;